import React, { useState, useRef, useEffect, useContext } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MuiTableSearch from "../../controls/MuiTableSearch";
import MuiTextField from "../../controls/MuiTextField";
import MuiAutoComplete from "../../controls/MuiAutoComplete";
import MuiDatePicker from "../../controls/MuiDatePicker";
import Alert from "../../controls/MuiSnackbarAlert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";

//Import Antd
import AntdMasterModal from "../../controls/AntdMasterModal";
import Draggable from "react-draggable";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { unwrapResult } from "@reduxjs/toolkit";

//Import React Router Dom
import { useNavigate } from "react-router-dom";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import from customerSlice.js
import {
  getCustomersFromServer,
  selectAllCustomers,
} from "../../masters/customer/customerSlice";

//Import from salesSlice.js
import { getOpeningBalanceFromCustomerMaster } from "../sales/salesSlice";

//Import from collectionSlice.js
import {
  addCollectionToServer,
  getCollectionsCountFromServer,
  getCollectionsFromServer,
  getCollectionsFromServerByPagination,
  updateCollectionInserver,
} from "./collectionSlice";

//Import CSS
import "./collection.css";

// { onClose }
const Collection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const customersList = useSelector(selectAllCustomers);
  const signinUser = useSelector(getSignInUser);

  //useState
  const [loginUser, setLoginUser] = useState(signinUser);
  const [showFieldsContainer, setShowFieldsContainer] = useState(true);
  //   const [isDialogOpen, setIsDialogOpen] = useState(true);
  const [collectionId, setCollectionId] = useState(0);
  const [salesNo, setSalesNo] = useState("");
  const [selectedSalesCollectionDate, setSelectedSalesCollectionDate] =
    useState(dayjs());
  const [isCollectionDatePickerOpen, setIsCollectionDatePickerOpen] =
    useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [openingBalance, setOpeningBalance] = useState(
    parseFloat(0).toFixed(2)
  );
  const [salesCollectionAmount, setSalesCollectionAmount] = useState("");
  const [collectionsList, setCollectionsList] = useState([]);
  const [originalCollectionsList, setOriginalCollectionsList] = useState([]);
  const [collectionsCount, setCollectionsCount] = useState(0);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  const [buttonSave, setButtonSave] = useState("Save");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [bounds, setBounds] = useState({
  //     left: 0,
  //     top: 0,
  //     bottom: 0,
  //     right: 0,
  //   });
  //End useState

  //useRef
  //   const draggleRef = useRef(null);
  const collectionDateRef = useRef(null);
  const customersRef = useRef(null);
  const openingBalanceRef = useRef(null);
  const collectionAmountRef = useRef(null);
  const saveRef = useRef(null);
  const cancelRef = useRef(null);
  const clearRef = useRef(null);
  //End useRef

  // useEffect
  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => setLoginUser(result.data));
    }

    const fetchDatas = async () => {
      try {
        // if (customersList.length > 0) {
        //   setCustomers(customersList);
        // } else {
        const result = await dispatch(getCustomersFromServer());
        const unwrappedCustomersResult = unwrapResult(result);
        unwrappedCustomersResult.data.length
          ? setCustomers(unwrappedCustomersResult.data)
          : setCustomers([]);
        // }

        const collectionsListResult = await dispatch(
          getCollectionsFromServer()
        );
        const unwrappedResult = unwrapResult(collectionsListResult);
        if (unwrappedResult.data.length > 0) {
          setOriginalCollectionsList(unwrappedResult.data);
        }

        const collectionsCountResult = await dispatch(
          getCollectionsCountFromServer()
        );
        const unwrappedCollectionCountResult = unwrapResult(
          collectionsCountResult
        );
        unwrappedCollectionCountResult.data[0].CollectionsCount === undefined
          ? setCollectionsCount(0)
          : setCollectionsCount(
              unwrappedCollectionCountResult.data[0].CollectionsCount
            );
      } catch (err) {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      }
    };

    setTimeout(() => {
      fetchDatas();
    }, 1000);
  }, []);

  useEffect(() => {
    fetchDatasbyPagination(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);
  // End useEffect

  const fetchDatasbyPagination = async (pageNo, rowSize) => {
    try {
      const result = await dispatch(
        getCollectionsFromServerByPagination({ pageNo, rowSize })
      );
      const unwrappedResult = unwrapResult(result);
      if (unwrappedResult.data.length === 0) {
        setNotify({
          isOpen: true,
          message: unwrappedResult.message,
          severity: "warning",
        });
        return;
      }
      if (Array.isArray(unwrappedResult.data))
        setCollectionsList(unwrappedResult.data);
    } catch (err) {
      console.log({ ErrorOccured: err });
      setNotify({
        isOpen: true,
        message: err.message,
        severity: "error",
      });
    }
  };

  //   const onStart = (_event, uiData) => {
  //     const { clientWidth, clientHeight } = window.document.documentElement;
  //     const targetRect = draggleRef.current?.getBoundingClientRect();
  //     if (!targetRect) {
  //       return;
  //     }
  //     setBounds({
  //       left: -targetRect.left + uiData.x,
  //       right: clientWidth - (targetRect.right - uiData.x),
  //       top: -targetRect.top + uiData.y,
  //       bottom: clientHeight - (targetRect.bottom - uiData.y),
  //     });
  //   };

  const handleCollectionAdd = (e) => {
    e.preventDefault();
    setShowFieldsContainer(true);
    resetfields();
    // collectionDateRef.current.focus();
  };

  const handleCollectionRefresh = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  const handleSales = () => {
    navigate("/sales");
  };

  const handleDateChange = (newValue) => {
    if (newValue && newValue.isValid()) {
      setSelectedSalesCollectionDate(newValue);
      setIsCollectionDatePickerOpen(false);
    }
  };

  const handleDateBlur = (event) => {
    const inputValue = event.target.value;
    const parsedDate = dayjs(inputValue, "DD/MM/YYYY", true);
    if (!parsedDate.isValid()) {
      // This is required
      // setError({
      //   salesDate: "Enter a valid date in DD/MM/YYYY format",
      //   customerName: "",
      //   itemName: "",
      //   quantity: "",
      //   uomName: "",
      //   unitPrice: "",
      // });
      setSelectedSalesCollectionDate(dayjs());
      setIsCollectionDatePickerOpen(false);
    } else {
      // This is required
      // setError({ salesDate: "" }); // Clear error if date is valid
      setSelectedSalesCollectionDate(parsedDate);
    }
  };

  const handleCustomerChange = async (e, value) => {
    e.preventDefault();
    setSelectedCustomer(value);
    if (value) {
      setCustomerCode(value.CUCode);
      setCustomerName(value.CUName);
      await dispatch(getOpeningBalanceFromCustomerMaster(value))
        .then(unwrapResult)
        .then((result) => {
          setOpeningBalance(
            parseFloat(result.data[0].OpeningBalance).toFixed(2)
          );
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });
      collectionAmountRef.current.focus();
    }
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 100 },
    {
      id: "Id",
      label: "Id",
      minWidth: 170,
    },
    { id: "SalesNo", label: "Sales No", minWidth: 170 },
    { id: "SalesDate", label: "Sales Date", minWidth: 170 },
    { id: "Customer", label: "Customer", minWidth: 170 },
    {
      id: "OpeningBalance",
      label: "Opening Balance",
      align: "right",
      minWidth: 170,
    },
    {
      id: "CollectionAmount",
      label: "Collection Amount",
      align: "right",
      minWidth: 170,
    },
  ];

  const handleCollectionSave = async () => {
    if (selectedSalesCollectionDate === null) {
      setNotify({
        isOpen: true,
        message: "Collection Date is required",
        severity: "warning",
      });
      collectionDateRef.current.focus();
      return;
    } else if (selectedCustomer === null) {
      setNotify({
        isOpen: true,
        message: "Customer is required",
        severity: "warning",
      });
      customersRef.current.focus();
      return;
    } else if (salesCollectionAmount === "") {
      setNotify({
        isOpen: true,
        message: "Collection Amount is required",
        severity: "warning",
      });
      collectionAmountRef.current.focus();
      return;
    } else {
      const formatedSalesCollectionDate = dayjs(
        selectedSalesCollectionDate
      ).format("DD/MM/YYYY");

      let newCollection = {
        selectedSalesCollectionDate: formatedSalesCollectionDate,
        customerCode,
        customerName,
        openingBalance,
        salesCollectionAmount,
        loginUser,
      };

      await dispatch(addCollectionToServer(newCollection))
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });

      await dispatch(getCollectionsCountFromServer())
        .then(unwrapResult)
        .then((result) => {
          setCollectionsCount(result.data[0].CollectionsCount);
        })
        .catch((error) => {
          console.log({ ErrorOccured: error });
          setNotify({
            isOp: true,
            message: error.message,
            severity: "error",
          });
        });

      await fetchDatasbyPagination(page + 1, rowsPerPage);
      resetfields();
      collectionDateRef.current.focus();
      //   setIsDialogOpen(false);
      //   onClose();
    }
  };

  //   const handleModalClose = () => {
  //     setIsDialogOpen(false);
  //     onClose(); // Trigger the parent to reset its state
  //   };

  //   const handleCollectionClose = (e) => {
  //     e.preventDefault();
  //     resetfields();
  //     setTimeout(() => {
  //       setIsDialogOpen(false);
  //       onClose();
  //     }, 500);
  //   };

  const handleCollectionCancel = (e) => {
    e.preventDefault();
    resetfields();
    setShowFieldsContainer(false);
    setButtonSave("Save");
  };
  const handleCollectionClear = () => {
    resetfields();
    collectionDateRef.current.focus();
  };

  const resetfields = () => {
    setCollectionId(0);
    setSalesNo("");
    setIsCollectionDatePickerOpen(false);
    setSelectedSalesCollectionDate(dayjs());
    setSelectedCustomer(null);
    setCustomerCode("");
    setCustomerName("");
    setOpeningBalance(parseFloat(0).toFixed(2));
    setSalesCollectionAmount("");
  };

  const handleCollectionEdit = (collection) => {
    let splitcustomercodename = collection.Customer;
    let [customercode, customername] = splitcustomercodename.split(" - ");
    let selectiveCustomer = customers.find(
      (customer) => customer.CUCode === customercode
    );
    showFieldsContainer
      ? customersRef.current.focus()
      : setShowFieldsContainer(true);
    setCollectionId(collection.Id);
    setSelectedSalesCollectionDate(
      dayjs(collection.SalesDate, "DD/MM/YYYY", true)
    );
    setSalesNo(collection.SalesNo);
    setSelectedCustomer(selectiveCustomer);
    setCustomerCode(selectiveCustomer.CUCode);
    setCustomerName(selectiveCustomer.CUName);
    setOpeningBalance(collection.OpeningBalance);
    setSalesCollectionAmount(collection.CollectionAmount);
    setButtonSave("Update");
  };

  const handleCollectionUpdate = async () => {
    if (selectedSalesCollectionDate === null) {
      setNotify({
        isOpen: true,
        message: "Collection Date is required",
        severity: "warning",
      });
      collectionDateRef.current.focus();
      return;
    } else if (selectedCustomer === null) {
      setNotify({
        isOpen: true,
        message: "Customer is required",
        severity: "warning",
      });
      customersRef.current.focus();
      return;
      // || isNaN(salesCollectionAmount)
    } else if (salesCollectionAmount === "") {
      setNotify({
        isOpen: true,
        message: "Collection Amount is required",
        severity: "warning",
      });
      collectionAmountRef.current.focus();
      return;
    } else {
      const formatedSalesCollectionDate = dayjs(
        selectedSalesCollectionDate
      ).format("DD/MM/YYYY");
      let updatedCollection = {
        salesNo,
        selectedSalesCollectionDate: formatedSalesCollectionDate,
        customerCode,
        customerName,
        openingBalance,
        collectionAmount: parseFloat(salesCollectionAmount).toFixed(2),
        loginUser,
      };
      await dispatch(
        updateCollectionInserver({ ...updatedCollection, collectionId })
      )
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
          } else if (result.flag === 2) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "warning",
            });
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        })
        .catch((err) => {
          console.log({ ErrorOccured: err });
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
          });
        });

      await fetchDatasbyPagination(page + 1, rowsPerPage);

      resetfields();
      collectionDateRef.current.focus();
      setButtonSave("Save");
    }
  };

  const handleSearch = (searchedVal) => {
    if (!searchedVal) {
      fetchDatasbyPagination(page + 1, rowsPerPage);
      return;
    } else {
      const filteredRows = originalCollectionsList.filter((collection) => {
        return (
          collection.Customer.toLowerCase().includes(
            searchedVal.toLowerCase()
          ) ||
          collection.SalesDate.includes(searchedVal) ||
          collection.CollectionAmount.includes(searchedVal)
        );
      });
      setCollectionsList(filteredRows);
    }
  };

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  return (
    <>
      {/* <AntdMasterModal
        width={650}
        title="Add Collection"
        centered
        open={isDialogOpen}
        onOk={() => {
          setIsDialogOpen(false);
        }}
        onCancel={handleModalClose}
        modalRender={(modal) => (
          <Draggable
            nodeRef={draggleRef}
            bounds={bounds}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
        footer={null}
      > */}
      <Box className="collectionboxcontainer">
        <Alert notify={notify} setNotify={setNotify} />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: "5px" }}
        >
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              onClick={handleCollectionAdd}
              sx={{ mb: "5px" }}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleCollectionRefresh}
              sx={{ mb: "5px", ml: "10px" }}
            >
              Refresh
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleSales}
              sx={{ mb: "5px", ml: "10px" }}
            >
              Sales
            </Button>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", alignItems: "center", mt: "-13px" }}
          >
            <MuiTableSearch
              placeholder="Search Collection"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Grid>
        </Grid>
        {showFieldsContainer ? (
          <Paper className="paper" elevation={2} sx={{ p: 2 }}>
            <h6>Add Collection</h6>
            <Divider />
            <CardContent>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sm={6} md={3}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MuiDatePicker
                      label="Collection Date"
                      value={selectedSalesCollectionDate}
                      onChange={handleDateChange}
                      open={isCollectionDatePickerOpen}
                      onClose={() => setIsCollectionDatePickerOpen(false)}
                      slotProps={{
                        textField: {
                          onClick: (e) => {
                            // Prevent the default click action and open the picker
                            e.stopPropagation();
                            setIsCollectionDatePickerOpen(true);
                          },
                          onBlur: handleDateBlur, // Add onBlur handler
                          inputRef: collectionDateRef,
                        },
                      }}
                      autoFocus
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiAutoComplete
                    id="customer"
                    clearOnEscape
                    autoHighlight
                    autoSelect
                    options={customers}
                    getOptionLabel={(option) =>
                      `${option.CUCode} - ${option.CUName}` || ""
                    }
                    value={selectedCustomer}
                    onChange={handleCustomerChange}
                    renderInput={(params) => (
                      <MuiTextField
                        {...params}
                        label="Customer *"
                        inputRef={customersRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            collectionDateRef.current.focus();
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    type="number"
                    id="openingbalance"
                    label="Opening Balance *"
                    InputProps={{
                      readOnly: true,
                    }}
                    onChange={(e) => {
                      setOpeningBalance(e.target.value);
                    }}
                    value={isNaN(openingBalance) ? "" : openingBalance}
                    inputRef={openingBalanceRef}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    type="number"
                    id="collectionamount"
                    label="Collection Amount *"
                    onChange={(e) => {
                      //   not allow to enter negative values - /^\d*\.?\d*$/
                      //   not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setSalesCollectionAmount(parseFloat(newValue));
                      }
                    }}
                    value={
                      isNaN(salesCollectionAmount) ? "" : salesCollectionAmount
                    }
                    inputRef={collectionAmountRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        customersRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12} sm={6} md={12} className="collectionButtons">
                  <div className="buttonGroup">
                    {buttonSave === "Save" ? (
                      <Button
                        variant="contained"
                        size="small"
                        className="btnsave"
                        ref={saveRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            collectionAmountRef.current.focus();
                        }}
                        onClick={handleCollectionSave}
                      >
                        Save
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        size="small"
                        className="btnupdate"
                        ref={saveRef}
                        onKeyDown={(e) => {
                          if (e.key.toLowerCase() === "home")
                            collectionAmountRef.current.focus();
                        }}
                        onClick={handleCollectionUpdate}
                      >
                        Update
                      </Button>
                    )}
                    <Button
                      className="btncancel"
                      variant="contained"
                      size="small"
                      ref={cancelRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          saveRef.current.focus();
                      }}
                      onClick={handleCollectionCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      className="btnclear"
                      ref={clearRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          cancelRef.current.focus();
                      }}
                      onClick={handleCollectionClear}
                    >
                      Clear
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        ) : (
          ""
        )}
      </Box>
      <Box
        className="collectionboxcontainer"
        sx={showFieldsContainer ? { mt: 3 } : { mt: 0 }}
      >
        <Paper elevation={2} sx={{ p: 2 }}>
          <TableContainer sx={{ maxHeight: 1000 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      hidden={column.id === "Id" ? true : false}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {collectionsList.length > 0 ? (
                  collectionsList.map((collection) => (
                    <TableRow key={collection.Id}>
                      <TableCell>
                        <EditIcon
                          className="editicon"
                          fontSize="medium"
                          onClick={() => handleCollectionEdit(collection)}
                        />
                      </TableCell>
                      <TableCell hidden={true}>{collection.Id}</TableCell>
                      <TableCell>{collection.SalesNo}</TableCell>
                      <TableCell>{collection.SalesDate}</TableCell>
                      <TableCell>{collection.Customer}</TableCell>
                      <TableCell align="right">
                        {collection.OpeningBalance}
                      </TableCell>
                      <TableCell align="right">
                        {collection.CollectionAmount}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No Collections found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            className="MuiTablePagination-selectLabel"
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={collectionsCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      {/* </AntdMasterModal> */}
    </>
  );
};

export default Collection;
